import Swiper from 'swiper'
import gsap from 'gsap'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import * as SmoothScroll from 'smooth-scroll'


export default function index(){
  const swiperParams = {
    slidesPerView: 3,
    spaceBetween: 50,
  }
  const swiper = new Swiper('.swiper', swiperParams)

  const fixbg = document.getElementById('fixbg')
  if(fixbg){
    fixbg.classList.add('active')
  }

  const fixbackground = document.getElementById('fixbackground')
  if(fixbackground){
    gsap.fromTo(fixbackground,
      {},
      {
        top: '-100%',
        scrollTrigger: {
          trigger: '#app',
          start: "top top",
          end: "top top-=100%",
          scrub: 3,
          once: false,
          //markers: true,
          invalidateOnRefresh: true,
        }
      }
    )
  }

  const fixPic = document.getElementById('fixPic')
  if(fixPic){
    gsap.fromTo(fixPic,
      {},
      {
        y: '-125vh',
        scale: .64,
        scrollTrigger: {
          trigger: '#app',
          start: "top top",
          end: "top top-=75%",
          scrub: 3,
          once: false,
          //markers: true,
          invalidateOnRefresh: true,
        }
      }
    )
  }

  const firstview = document.getElementById('firstview')
  if(firstview){
    firstview.classList.add('active')
    gsap.fromTo(firstview,
      {},
      {
        y: '-12.5vh',
        opacity: 0,
        scrollTrigger: {
          trigger: '#app',
          start: "top top",
          end: "top top-=25%",
          scrub: 3,
          once: false,
          //markers: true,
          invalidateOnRefresh: true,
        }
      }
    )
  }


  const catWark = document.getElementById('catWark')
  if(catWark){
    gsap.fromTo(catWark,
      {},
      {
        left: '20%',
        scrollTrigger: {
          trigger: catWark,
          start: "top bottom",
          end: "bottom top-=15%",
          scrub: 0,
          once: false,
          //markers: true,
          invalidateOnRefresh: true,
        }
      }
    )
  }

  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;
    const cat = Math.floor(scrollY / 10) * 120
    document.documentElement.style.setProperty('--cat', `${cat * -1}px`)
  });
}